module.exports = __webpack_public_path__ + "img/sgreklaam.3156c256.png";